import ApiClient from './ApiClient';

class SmartCampaignsAPI extends ApiClient {
  constructor() {
    super('smart_campaigns', { accountScoped: true });
  }
}

export default new SmartCampaignsAPI();
